import React from 'react';

import ply from '../../images/l2.jpg';
import acrylic from '../../images/a1.jpg';
import louvers from '../../images/lo2.jpg';
import { useNavigate } from 'react-router-dom';

const WorkingSection = () => {
   
    const navigate = useNavigate();

    return (
        <section className="w-full bg-white px-4 py-16" >
            <div className="max-w-7xl mx-auto justify-center">
                {/* Top Section */}
                <div className="flex flex-col lg:flex-row gap-6 relative">
                    {/* Left Image Grid */}
                    <div className="flex flex-col gap-4 flex-1 z-0">
                        <div>
                            <img
                                src={ply}
                                alt="Plywood cabinet sample"
                                className="w-full h-[250px] md:h-[300px] object-cover rounded"
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <img
                                src={acrylic}
                                alt="Acrylic panel sample"
                                className="w-full h-[150px] md:h-[180px] object-cover rounded"
                            />
                            <img
                                src={louvers}
                                alt="Wooden louvers close-up"
                                className="w-full h-[150px] md:h-[180px] object-cover rounded"
                            />
                        </div>
                    </div>

                    {/* Overlay Box Section */}
                    <div className="flex-1 relative z-10 lg:-ml-24 lg:mt-24">
                        <div className="w-full lg:w-[85%] bg-[#8A5834]/90 text-white p-6 md:p-10 rounded shadow-lg">
                            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-tight">
                            Explore Premium
                                <br />
                                Navkar Laminates
                            </h1>
                            <p className="text-sm md:text-base mb-6 max-w-md">
                            Durable, versatile, and crafted for excellence Navkar Laminates is the trusted choice for all your construction and interior needs.
                            </p>
                            <button
                                className="bg-white text-[#8A5834] px-5 py-2 text-sm font-semibold rounded hover:bg-black hover:text-white transition"
                                onClick={() => navigate('/Products')}
                            >
                                Learn More
                            </button>
                        </div>
                    </div>
                </div>


            </div>
        </section>
    );
};

export default WorkingSection;
